import { SideDrawer } from '@sales-center/components'
import React from 'react'
import { useSelector } from 'react-redux'
import {
  salesCenterWebhookModel,
  selectSCWebHookFilters,
} from '@user/store/scWebHooks'
import { Formik } from 'formik'
import { useActions } from '@user/components/Settings/SCWebhooks/SCWebhookSideSheet/hooks/useActions'
import { SCWebhookSideSheetForm } from '@user/components/Settings/SCWebhooks/SCWebhookSideSheet/SCWebhookSideSheetForm'

export interface Props {
  open: boolean
  handleClose: () => void
}

export const SCWebhookSideSheet = (props: Props) => {
  const { open, handleClose } = props
  const { selectedWebHook } = useSelector(selectSCWebHookFilters)
  const { handleSubmit, validate } = useActions(handleClose)

  return (
    <SideDrawer
      open={open}
      title={selectedWebHook ? 'Edit Webhook' : 'Create Webhook'}
      onClose={handleClose}
      tidalThemeActive={true}
      width={495}
      titleVariant="h5"
    >
      <Formik
        enableReinitialize
        initialValues={salesCenterWebhookModel}
        onSubmit={handleSubmit}
        validate={validate}
      >
        <SCWebhookSideSheetForm handleClose={handleClose} />
      </Formik>
    </SideDrawer>
  )
}
